/* eslint camelcase: "off" */
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { graphql, compose, withApollo } from 'react-apollo'
import DocumentIcon from '../documents/DocumentIcon'
import { RejectedModal } from '../documents/modals'
import Note from '../documents/Note'
import SuccessNotification from '../common/SuccessNotification'
import Modal from '../common/Modal'
import UploadContainer from '../documents/UploadContainer'
import WithLoan from '../shared/WithLoan'
import UpdateDocumentStatus from '../documents/queries/UpdateDocumentStatus'
import UpdateDocumentFileStatus from '../documents/queries/UpdateDocumentFileStatus'
import DocumentsQuery from '../documents/queries/DocumentsQuery'
import MarkFileAsRead from '../documents/queries/MarkFileAsRead'
import UpdateDocumentComment from '../documents/queries/UpdateDocumentComment'

const ContainerBucket = styled.div`
  display: grid;
  grid-template-columns: 0fr 1fr;
  &:not(:last-child) {
    border-bottom: 1px solid #eeeeee;
  }
  margin: 20px 0;
`
const ContainerInfo = styled.div`
  display: grid;
  padding: 0 20px;
`
const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  min-width: 0;
  &:not(:last-child) {
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 20px;
  }
`
const LeftContainer = styled.div`
  display: grid;
  border-right: 1px solid #eeeeee;
  padding-right: 10px;
  min-width: 0;
`
const RightContainer = styled.div`
  margin-left: 16px;
`
const DocumentControls = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
const StatusSelect = styled.select`
  max-width: 250px;
  margin-top:5px;
`
const File = styled.i`
  display: flex;
  justify-content: flex-start;
  color: #56565a;
`
const Link = styled.a`
  color: #56565a;
  cursor: pointer;
  text-overflow: ellipsis;
  &:hover {
    color: #56565a;
  }
`
const FileName = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
`
const New = styled.div`
  padding: 0px 10px;
  background: #dd6a01;
  border-radius: 3px;
  color: white;
  font-size: 85%;
  height: 20px;
`
const Grey = styled.p`
  justify-self: end;
  color: #cccccc;
`
const TitleContainerReference = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin-bottom: 10px;
  b {
    margin-left: 10px;
    display: inline-block;
  }
`
const TitleContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin-bottom: 10px;
  b {
    display: inline-block;
  }
`
const Title = styled.div`
  margin-left: 10px;
  display: flex;
  justify-content: space-between;
`
const DisabledLinkHelper = styled.div`
  position: relative;
  color: darkgrey;
`
const ErrorMessages = styled.div`
  color: #cc2626;
`

const statusOptionsFile = {
  pending_review:         'Pending Review',
  conditionally_approved: 'Conditionally Approved',
  rejected:               'Rejected',
  approve_and_commit:     'Approve and Commit',
  move_to_archived:       'Move to Archived',
  un_archive:             'Un-Archive'
}

const statusOptions = {
  empty:                  'Choose Status',
  ...statusOptionsFile,
  not_required:           'Not Required',
  esign_requested:        'E-Sign Requested'
}

class EtranDocument extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isChangingStatus:                  false,
      isDocumentBucketModalOpen:         false,
      isRejectedModalOpen:               false,
      isDeleteModalOpen:                 false,
      isPrepareEsignModalOpen:           false,
      isUploading:                       false,
      isSuccessNotificationVisible:      false,
      isRequestSentModalOpen:            false,
      isEsignUrlModalOpen:               false,
      isCancelEsignModalOpen:            false,
      isSignatureRequestStatusModalOpen: false,
      isSignatureRequestReminderModal:   false,
      isOrderTranscriptsModalOpen:       false,
      is4506tLoading:                    false,
      lastRejectedRef:                   null,
      errorMessage:                      '',
      isEmptyDocument:                   props.document.files.length === 0
    }
  }
  toggleState = state => {
    this.setState({
      [state]: !this.state[state]
    })
  }
  toggleSuccessNotification = () => {
    const { isSuccessNotificationVisible } = this.state
    if (this.successNotificationTimeout && isSuccessNotificationVisible) {
      clearTimeout(this.successNotificationTimeout)
      this.successNotificationTimeout = null
    }
    this.toggleState('isSuccessNotificationVisible')
  }
  flashSuccessNotification = () => {
    const { setSubmitButtonDisabled, validInput, etranInfo } = this.props
    setSubmitButtonDisabled(validInput(etranInfo), etranInfo)
    this.setState({ isSuccessNotificationVisible: true })
    this.successNotificationTimeout = setTimeout(() => {
      this.setState({ isSuccessNotificationVisible: false })
    }, 4000)
  }
  changeStatus = status => {
    this.setState({ status })
  }
  updateDocumentData = (documentData, store, loanState, currentStatus) => {
    const { entityId, loanId, document, loan } = this.props
    const { rid } = document
    const data = store.readQuery({ query: DocumentsQuery, variables: { rid: loanId } })
    if (data.loan) {
      const { affiliates, businesses } = data.loan
      const business = this.getEntity(businesses, entityId) || this.getEntity(affiliates, entityId)
      const { documents } = business
      this.updateDocumentByIndex(documents, rid, currentStatus, documentData)
      store.writeQuery({ query: DocumentsQuery, variables: { rid: loanId }, data })
    }
  }
  documentsConfirmed = entities => {
    const allDocuments = entities.reduce((allDocs, { documents }) => {
      return allDocs.concat(documents)
    }, [])

    return allDocuments.every(({status}) => ["approve_and_commit", "not_required"].includes(status))
  }
  directUrlToGlobalSearchPage = loanAppNumber => {
    window.location.reload();

    return `/admin/loans/${loanAppNumber}`;
  }
  getEntity = (entities, entityId) => (
    entities.find(({ rid })=> rid === entityId)
  )
  updateDocumentByIndex = (documents, rid, status, documentData) => {
    const index = documents.findIndex(({rid: id }) => id === rid)
    const hasDocument = index > -1

    if (hasDocument) {
      this.updateDocumentList(documents, status, index, documentData)
    }
  }
  updateDocumentList = (documents, status, index, documentData) => {
    if (['move_to_archived', 'un_archive'].includes(status)) {
      documents.splice(index, 1)
    } else {
      documents[index] = documentData
    }
  }
  onStatusFileChange = ({target}, reference) => {
    const { value } = target
    this.updateStatusFile(value, reference)
  }
  checkBucketStatus = (reference, status) => {
    const { referenceFiles } = this.props.document
    const arrayStatus = JSON.parse(referenceFiles).map(({ status }) => status)
    let value
    let openReject = status === 'rejected'

    if (arrayStatus.includes('conditionally_approved')) {
      value = 'conditionally_approved'
    } else if (arrayStatus.includes('pending_review')) {
      value = 'pending_review'
    } else if (arrayStatus.includes('rejected')) {
      value = 'rejected'
    } else if (arrayStatus.filter(s => s === 'approve_and_commit').length === arrayStatus.length) {
      value = 'approve_and_commit'
    }
    if (status === 'rejected') {
      this.setState({ lastRejectedRef: reference })
    }
    this.updateStatusBucket(value, openReject)
  }
  updateStatusFile = async (value, reference) => {
    const { updateDocumentFileStatus, document: { doc: { rid } } } = this.props
    const { date } = reference

    await updateDocumentFileStatus({
      variables: {
        input: {
          documentId: rid,
          fileStatus: value,
          referenceDate: date
        }
      },
      update: (store, { data: { updateDocumentFileStatus: { document } } }) => {
        this.updateDocumentData(document, store)
      }
    })
    await this.checkBucketStatus(reference, value)
  }
  updateStatusBucket = async (value, openReject) => {
    const { updateDocumentStatus, updateDocumentComment, document: doc } = this.props
    const { status, rid: documentId } = doc

    if (value === 'rejected' && openReject) {
      this.toggleState('isRejectedModalOpen')
    } else if (status !== value && status !== '1') {
      this.setState({ status: value })
      await this.toggleState('isChangingStatus')

      await updateDocumentStatus({
        variables: {
          input: {
            documentId,
            status: value
          }
        },
        update: (store, { data: { updateDocumentStatus: { document, loanState } } }) => {
          this.updateDocumentData(document, store, loanState, value)
        }
      }).catch((errors) => {
        const errorMessage = errors.message.replace(/^[A-Z][A-Za-z]*\serror:\s/g, '')

        this.setState({ errorMessage })
      })
      if (value === 'approve_and_commit') {
        setTimeout(async () => {
          await updateDocumentComment({
            variables: {
              input: {
                documentId,
                comment: null
              }
            },
            update: (store, { data: { updateDocumentComment: { document } } }) => {
              this.updateDocumentData(document, store)
            }
          })
        }, 100)
      }
      this.toggleState('isChangingStatus')
    }
  }
  onStatusChange = ({ target }) => {
    const { value } = target

    this.updateStatusBucket(value, true)
  }
  onFilenameClick = async (fileName) => {
    const { markFileAsRead, document : { rid } } = this.props

    try {
      await markFileAsRead({
        variables: {
          input: {
            documentId: rid,
            fileName
          }
        },
        update: (store, { data: { markFileAsRead: { document } } }) => {
          this.updateDocumentData(document, store)
        }
      })
      this.decrementNotificationCount()
    } catch (err) {
      console.log(err)
    }
  }
  decrementNotificationCount = () => {
    // Until the left sidebar is refactored in react, we need to grab it with getElementById and manually decrement the counter
    const { resourceType, idx, document : { files } } = this.props
    const newCount = files.filter(f => f.isNew).length
    const parseInner = innerHTML => {
      const [value] = innerHTML.split(' ')

      return parseInt(value, 10)
    }

    if (newCount === 0){
      let notification

      if (resourceType === 'Business'){
        const docsTab = document.getElementById(`business-docs-tab-${idx}`)
        notification = docsTab.querySelector('#new-business-docs-counter')
      }
      if (notification){
        const notificationCount = parseInner(notification.innerHTML)

        if (notificationCount === 1){
          notification.remove()
        } else {
          notification.innerHTML = `${notificationCount - 1} New`
        }
      }
    }
  }
  renderStatusIcon = () => {
    const { isChangingStatus } = this.state
    const { status, uploaded } = this.props.document
    let option

    if (!uploaded) {
      option = {
        iconClass: 'cloud-upload',
        color: '#808080'
      }
    } else {
      const options = {
        empty: {
          iconClass: 'file-text-o',
          color: '#ce7019'
        },
        approve_and_commit: {
          iconClass: 'check',
          color: '#339952'
        },
        pending_review: {
          iconClass: 'file-text-o',
          color: '#ce7019'
        },
        rejected: {
          iconClass: 'ban',
          color: '#BC3C4B'
        },
        conditionally_approved: {
          iconClass: 'check',
          color: '#e0e8e9'
        },
        not_required: {
          color: '#808080',
          child: 'N/A'
        },
        esign_requested: {
          iconClass: 'pencil-square-o',
          color: '#AD3B72'
        }
      }
      option = options[status]
    }
    const { iconClass, color, child } = option

    return (
      <DocumentIcon loading={isChangingStatus} className={`fa fa-${iconClass}`} color={color}>
        {child}
      </DocumentIcon>
    )
  }
  renderOptionsFiles = () => {
    const options = Object.keys(statusOptionsFile)

    return options.map(opt => (
      <option key={opt} value={opt}>{statusOptionsFile[opt]}</option>
    ))
  }
  removeOption = (options, optionValue) => {
    const indexOfOptionValue = options.indexOf(optionValue)

    options.splice(indexOfOptionValue, 1)
  }
  renderOptions = () => {
    const { customerService, superUser, document: doc, resourceType } = this.props
    const { skippable, status, type, uploaded } = doc

    const options = Object.keys(statusOptions)

    if (!customerService) {
      this.removeOption(options, 'move_to_archived')
    }

    if (customerService && (type !== 'Document::Custom' || resourceType === 'Archived')) {
      this.removeOption(options, 'move_to_archived')
    }

    if (type !== 'Document::Custom' || resourceType !== 'Archived') {
      this.removeOption(options, 'un_archive')
    }

    if (status !== 'esign_requested') {
      this.removeOption(options, 'esign_requested')
    }

    return options.map(opt => {
      const option = <option key={opt} value={opt}>{statusOptions[opt]}</option>

      if (opt !== 'approve_and_commit' && !uploaded && skippable){

        return option
      } else if (!uploaded && skippable){

        return
      }
      if (opt === 'empty' && status !== 'empty'){ // Only show 'Choose Status' if document status is nil
        return
      } else if ((type === 'Document::LienPerfection' || type === 'Document::Signed') && opt === 'approve_and_commit'){
        return (
          <option key={opt} value={opt}>Upload After Funding</option>
        )
      } else if (status === 'approve_and_commit' && !superUser && opt !== 'approve_and_commit'){ // only super users can change status if it is approve and commit
        return
      } else if (opt !== 'not_required' || (skippable && opt === 'not_required')){
        return option
      }
    })
  }
  renderStatus = hasReferences => {
    if (!hasReferences) {
      const { superUser } = this.props
      const { skipped, confirmed, status, uploaded, skippable } = this.props.document

      if (skipped && !superUser) {
        return (
          <p>This Document is not Required</p>
        )
      } else if (confirmed && !superUser) {
        return (
          <p>Approved and Committed</p>
        )
      } else if (!uploaded && ['empty', 'pending_review'].includes(status) && !skippable) {
        return (
          <p>No Documents Uploaded</p>
        )
      } else {

        return (
          <StatusSelect
            id="status_select"
            value={status}
            onChange={(e) => this.onStatusChange(e)}>
              {this.renderOptions()}
          </StatusSelect>
        )
      }
    }
  }
  renderStatusFiles = reference => {
    const files = this.getFilenames(reference)

    if (files.length <= 0) {
      return (
        <div>No Documents Uploaded</div>
      )
    }
    const { status } = reference
    return (
      <StatusSelect
        id="status_select"
        value={status}
        onChange={e => this.onStatusFileChange(e, reference)}>
          {this.renderOptionsFiles()}
      </StatusSelect>
    )
  }
  getFilenames = referenceFileDate => {
    const { document } = this.props
    const filteredFilenames = []
    const { files } = document

    if (!referenceFileDate || !document) {
      return files
    }
    const { date } = referenceFileDate

    files.map(file => {
      if (moment(file.referenceDate).isSame(date, 'month')) {
        filteredFilenames.push(file)
      }
    })
    return filteredFilenames
  }
  renderFilenames = reference => {
    const { rid, fileUrls } = this.props.document

    return (
      this.getFilenames(reference).map((file, i) => {
        const fileUrl = fileUrls.find(f => f.filename === file.name)

        return (
          <FileName key={`${file.name}-${rid}-${i}`}>
            <File className="fa fa-file-text-o">
                &nbsp;
              <Link
                onClick={file.isNew ? () => this.onFilenameClick(file.name) : () => {}}
                href={fileUrl ? fileUrl.link : null}
                title={file.name}
                target='_blank'
                id="file_link"
              >
                {file.trimmedFilename}
              </Link>
            </File>
            {file.isNew && <New id="new_file_notification">New</New>}
          </FileName>
        )
      })
    )
  }
  renderRejectedModal = () => {
    const { document: doc} = this.props
    const { isRejectedModalOpen, lastRejectedRef } = this.state

    return (
      <Modal light isModalOpen={isRejectedModalOpen}>
        <RejectedModal
          document={doc}
          toggleModal={() => this.toggleState('isRejectedModalOpen')}
          toggleChangingStatus={() => this.toggleState('isChangingStatus')}
          changeStatus={this.changeStatus}
          lastRejectedRef={lastRejectedRef}
          getKeyRef={this.getKeyRef}
          generateHash={this.generateHash}
          updateDocumentData={this.updateDocumentData}
          updateNotes={this.updateNotes}
        />
      </Modal>
    )
  }
  getMomentDate = date => {
    return moment(date, 'YYYY-MM-DD')
  }
  getKeyRef = date => {
    return this.getMomentDate(date).format('MM_YYYY')
  }
  renderNote = reference => {
    const { updateNotes } = this.state
    const { document: doc } = this.props
    const { rid } = doc
    let  { referenceFiles } = doc

    referenceFiles = JSON.parse(referenceFiles)
    return (
      <Note
        id={`borrower_note_${rid}_document`}
        updateDocumentData={this.updateDocumentData}
        referenceFiles={referenceFiles}
        reference={reference}
        getKeyRef={this.getKeyRef}
        updateNotes={updateNotes}
        {...this.props}
      />
    )
  }
  renderControls = reference => {
    const { disabled } = this.props
    const { live } = this.props.document
    const key = reference ? reference.date : ''

    if (live && !disabled) {
      return (
        <UploadContainer
          flashSuccessNotification={this.flashSuccessNotification}
          reference={reference}
          referenceKey={key}
          {...this.props}
        />
      )
    }
  }
  renderSuccessNotification = () => {
    if (this.state.isSuccessNotificationVisible) {
      return (
        <SuccessNotification duration={3}
          onClose={this.toggleSuccessNotification}
          text="Document successfully updated."
        />
      )
    }
  }
  renderReferenceContainer = referenceFiles => {
    return (
      referenceFiles.map(referenceDate => (
        <Fragment key={`reference-${referenceDate.date}`}>
          {this.renderContainer(referenceDate)}
        </Fragment>
      ))
    )
  }
  renderContainer = reference => {
    const getTitle = () => {
      if (reference) {
        const { date } = reference
        const dateFormat = this.getMomentDate(date).format('MMMM YYYY')

        return (
          <TitleContainerReference>
            {this.renderStatusFiles(reference)}
            <b>{dateFormat}</b>
          </TitleContainerReference>
        )
      }

      return null
    }
    return (
      <div id='document_bucket_box'>
        {getTitle()}
        <Container>
          <LeftContainer>
            <DocumentControls>
              {this.renderFilenames(reference)}
              {this.renderControls(reference)}
            </DocumentControls>
          </LeftContainer>
          <RightContainer>
            {this.renderNote(reference)}
          </RightContainer>
          {this.renderRejectedModal()}
          {this.renderSuccessNotification()}
        </Container>
      </div>
    )
  }
  render() {
    const {  document: doc } = this.props
    const { title, adminOnly, rid } = doc
    let  { referenceFiles } = doc
    referenceFiles = JSON.parse(referenceFiles)
    const hasReferences = referenceFiles.length > 0
    const { errorMessage } = this.state

    return (
      <ContainerBucket id="document_bucket_container">
        {this.renderStatusIcon()}
        <ContainerInfo>
          <ErrorMessages>
            {errorMessage}
          </ErrorMessages>
          <TitleContainer>
            {this.renderStatus(hasReferences)}
            <Title>
              <b id={`document_title_${rid}`}>
                {title}
              </b>
              <Grey>{`${adminOnly ? 'Admin' : 'Borrower'} Document`}</Grey>
            </Title>
          </TitleContainer>
          { hasReferences ? this.renderReferenceContainer(referenceFiles) : this.renderContainer() }
        </ContainerInfo>
      </ContainerBucket>
    )
  }
}

export { EtranDocument }

export default compose(
  graphql(UpdateDocumentStatus, {
    name: 'updateDocumentStatus'
  }),
  graphql(UpdateDocumentFileStatus, {
    name: 'updateDocumentFileStatus'
  }),
  graphql(MarkFileAsRead, {
    name: 'markFileAsRead'
  }),
  graphql(UpdateDocumentComment, {
    name: 'updateDocumentComment'
  }),
  WithLoan,
  withApollo
)(EtranDocument)
